import { eventsData } from "../data/eventsData";
import { Link } from "react-router-dom";

export const selectedShows = [2, 7, 13, 14, 20, 22]

export default function ListenAgain() {
  return (
    <div className="py-10">
      <h1>Listen Again Happy Radio UK</h1>
      <p className="text-center font-light pb-8">
        Listen again to your favourite shows from the last 7 days on Happy Radio UK!
      </p>
      <div className="grid grid-cols-1 gap-8 mx-4 sm:grid-cols-3 lg:grid-cols-4 lg:mx-48">
        {eventsData.filter((event) => selectedShows.includes(event.id)).map((event) => (
          <Link to={`/schedule/${event.id}`} key={event.id} className="block hover:bg-gray-50 transition-colors">
            <li className="card relative">
              <img src={event.playbackImage || event.image} alt={event.name} width={600} height={600} className="w-full object-cover" />
              {/* <div className="absolute bottom-0 left-0 bg-black bg-opacity-50 w-full p-4">
                <div className="flex items-center">
                  <p className="text-sm font-semibold text-white">{event.name}<span className="font-normal">&nbsp;|&nbsp;{event.time}:00</span></p>
                </div>
                <p className="text-xs md:text-sm text-gray-300">{event.playbacks.length}&nbsp;episodes</p>
              </div> */}
            </li>
          </Link>
        ))}
      </div>
    </div>
  )
}